import { values } from '@fortem-monorepo/js-utilities';
export const FACTOR = {
    Agf: 'AGF',
    Amc: 'AMC',
    AssetSwap: 'Asset Swap',
    Benchmark: 'Benchmark',
    Beta: 'Beta',
    BondCarry: 'Bond Carry',
    BondCurve: 'Bond Curve',
    BondVolatility: 'Bond Volatility',
    Carry: 'Carry',
    CommodityCarry: 'Commodity Carry',
    CommodityCongestion: 'Commodity Congestion',
    CommodityCurve: 'Commodity Curve',
    CommodityMomentum: 'Commodity Momentum',
    CommodityValue: 'Commodity Value',
    CrossAssetMomentum: 'Cross Asset Momentum',
    Dgf: 'DGF',
    EquitiesCarry: 'Equities Carry',
    EquitiesCongestion: 'Equities Congestion',
    EquitiesLiquidity: 'Equities Liquidity',
    EquitiesMomentum: 'Equities Momentum',
    EquitiesMultiFactor: 'Equities Multi Factor',
    EquitiesSize: 'Equities Size',
    EquitiesValue: 'Equities Value',
    EquitiesVolatility: 'Equities Volatility',
    Equity: 'Equity',
    EquityMultiStyle: 'Equity Multi-style',
    EquityVolatility: 'Equity Volatility',
    EuropeanEquityVolArb: 'European Equity Vol Arb',
    FxCarry: 'FX Carry',
    FxCongestion: 'FX Congestion',
    Gold: 'Gold',
    Growth: 'Growth',
    Imbalance: 'Imbalance',
    Liquidity: 'Liquidity',
    LowBeta: 'Low Beta',
    Macro: 'Macro',
    Momentum: 'Momentum',
    MultiFactor: 'Multi-Factor',
    Property: 'Property',
    Quality: 'Quality',
    RatesCarry: 'Rates Carry',
    RatesCurve: 'Rates Curve',
    RatesMultiStrat: 'Rates Multi -strat',
    SptrIndex: 'SPTR Index',
    Size: 'Size',
    UsEquityVolArb: 'US Equity Vol Arb',
    Usd: 'USD',
    Value: 'Value',
    Volatility: 'Volatility',
    XAssetVolatility: 'X Asset Volatility',
};
export const FACTORS = values(FACTOR);
